import type { IconData } from '@stacksjs/iconify-core'

export const phone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m449.366 89.648l-.685-.428l-86.593-42.661l-93.463 124.617l43 57.337a88.53 88.53 0 0 1-83.115 83.114l-57.336-43l-124.616 93.461l42.306 85.869l.356.725l.429.684a25.09 25.09 0 0 0 21.393 11.857h22.344a327.836 327.836 0 0 0 327.836-327.837v-22.345a25.08 25.08 0 0 0-11.856-21.393m-20.144 43.738c0 163.125-132.712 295.837-295.836 295.837h-18.08L87 371.76l84.18-63.135l46.867 35.149h5.333a120.535 120.535 0 0 0 120.4-120.4v-5.333l-35.149-46.866L371.759 87l57.463 28.311Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default phone
